/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "@app/@core/services/api";

@Injectable()
export class AdminPayrollService {
  constructor(private apiService: ApiService, private router: Router) {}

  getBatch(year = null, month = null) {
    let url = "admin/payroll";
    url += year && month ? "/" + year + "/" + month : "";
    return this.apiService.get(url);
  }
  
  toggleBatchRelease(year, month, release){
    return this.apiService.post("admin/payroll/batch/" + year + "/" + month + "/release", {release});
  }

  approveBatch(year, month){
    return this.apiService.post("admin/payroll/batch/" + year + "/" + month + "/approve");
  }

  downloadReport(key){
    return this.apiService.download("admin/payroll/download_report/" + key);
  }

  getFeeds(year, month) {
    let url = "admin/payroll/feeds/" + year + "/" + month;
    return this.apiService.get(url);
  }

  getRecords(feed_id) {
    let url = "admin/payroll/feeds/records";
    return this.apiService.post(url, {feed_id});
  }

  processFeed(form_data) {
    let url = "admin/payroll/feeds/process";
    return this.apiService.post(url, form_data);
  }
 
  uploadFeed(year, month, form_data) {
    let url = "admin/payroll/feeds/" + year + "/" + month;
    return this.apiService.upload(url, form_data);
  }

  deleteFeed(feed_id){
    return this.apiService.delete("admin/payroll/feeds/" + feed_id);
  }

  downloadFeed(feed_id){
    return this.apiService.download("admin/payroll/feeds/download/" + feed_id);
  }
  
  generateBatchSummary(year, month){
    return this.apiService.post("admin/payroll/generate_batch_summary/" + year + "/" + month);
  }
  
  generateFeedRecords(feed_id){
    return this.apiService.post("admin/payroll/feeds/generate_export_records/" + feed_id);
  }

  generateFeedRecordsByBatch(batch_id){
    return this.apiService.download("admin/payroll/feeds/generate_export_records_by_batch/" + batch_id);
  }

  generateFeedComputations(feed_id){
    return this.apiService.post("admin/payroll/feeds/generate_export_computations/" + feed_id);
  }

  downloadGeneratedExport(key){
    return this.apiService.download("admin/payroll/download_export/" + key);
  }
  
  generateCsvExport(year, month){
    return this.apiService.post("admin/payroll/generate_csv_export/" + year + "/" + month);
  }

  generateProvidersBreakdown(year, month){
    return this.apiService.post("admin/payroll/generate_providers_breakdown/" + year + "/" + month);
  }

  getRepsForPayslipsPreview(year, month){
    return this.apiService.get("admin/payroll/reps_for_payslips_preview/" + year + "/" + month);
  }
}
